import { times } from "lodash";

import { AgentList } from "src/agentNode/components/agentSelectionModal/AgentList";
import { AgentVersionList } from "src/agentNode/components/agentSelectionModal/AgentVersionList";
import { useAgents, useAgentVersions } from "src/agents/queries/management";
import { SkeletonPlaceholder } from "src/base-components/SkeletonPlaceholder";
import { Agent, AgentVersion } from "src/clients/agent-management";

type Props = {
  selectedAgent: Agent | null;
  onAgentSelect: (agent: Agent) => void;
  selectedVersionId?: string;
  onVersionSelect: (version: AgentVersion) => void;
};

const ListSkeleton: React.FC = () => (
  <div className="flex flex-col gap-y-3">
    {times(4, (i) => (
      <div key={i} className="rounded-lg border border-gray-200 p-4">
        <SkeletonPlaceholder height="h-4" width="w-32" />
        <div className="mt-2">
          <SkeletonPlaceholder height="h-3" width="w-full" />
        </div>
        <div className="mt-4 flex gap-1">
          <SkeletonPlaceholder height="h-5" width="w-20" />
        </div>
      </div>
    ))}
  </div>
);

export const SelectAgentAndVersion: React.FC<Props> = ({
  selectedAgent,
  onVersionSelect,
  selectedVersionId,
  onAgentSelect,
}) => {
  const agentsQuery = useAgents();
  const versionsQuery = useAgentVersions(selectedAgent?.id ?? "");

  if (selectedAgent) {
    if (versionsQuery.isLoading) {
      return <ListSkeleton />;
    }
    return (
      <AgentVersionList
        selectedVersionId={selectedVersionId}
        versions={versionsQuery.data ?? []}
        onSelect={onVersionSelect}
      />
    );
  }

  if (agentsQuery.isLoading) {
    return <ListSkeleton />;
  }

  return <AgentList agents={agentsQuery.data ?? []} onSelect={onAgentSelect} />;
};
